import Bugsnag from "@bugsnag/js";
import { client } from "@nju/http-client";
import { ok } from "@nju/result";
import { IFetchOrderResult } from "./types";
import {
  IAccess,
  IAdditionalTask,
  ICyberSecurity,
  IInternet,
  IModem,
  ISfh,
  serverResponse,
} from "./validators";

interface IFetchOrderProps {
  orderId: string;
  version: string;
}

export async function fetchOrder({
  orderId,
  version,
}: IFetchOrderProps): Promise<IFetchOrderResult> {
  const result = await client(
    `${process.env.NEXT_PUBLIC_PUBLIC_GATEWAY_HOST}/orders/${orderId}`,
    {
      headers: {
        apikey: process.env.NEXT_PUBLIC_APIKEY || "unknown",
        version,
      },
      validator: serverResponse,
    },
  );

  if (result.isError) {
    Bugsnag.notify(result.err);
    return result;
  }

  const internet = result.value.orderItem.find(({ product }) => {
    return product.productSpecificationId === "INTERNET";
  }) as IInternet | undefined;

  const cybersecurity = result.value.orderItem.find(({ product }) => {
    return product.productSpecificationId === "CYBERSECURITY";
  }) as ICyberSecurity | undefined;

  const access = result.value.orderItem.find(({ product }) => {
    return product.productSpecificationId === "ACCESS";
  }) as IAccess | undefined;

  const additionalTask = result.value.orderItem.find(({ product }) => {
    return product.productSpecificationId === "ADDITIONALTASK";
  }) as IAdditionalTask | undefined;

  const modem = result.value.orderItem.find(({ product }) => {
    return product.productSpecificationId === "MODEM";
  }) as IModem | undefined;

  const sfh = result.value.orderItem.find(({ product }) => {
    return product.productSpecificationId === "SFH";
  }) as ISfh | undefined;

  const utechUserUrl = result.value.utechUserUrl;
  const utechAgentUrl = result.value.utechAgentUrl;

  return ok({
    sfh,
    internet,
    cybersecurity,
    access,
    additionalTask,
    modem,
    utechUserUrl,
    utechAgentUrl,
    id: result.value.id,
    dopUserId: result.value.dopUserId,
    paymentStatus: result.value.paymentStatus,
    status: result.value.status,
    orderDate: result.value.orderDate,
    appointment: result.value.appointment,
    installationAddress: result.value.installationAddress,
    delivery: result.value.delivery,
    waybillNumber: result.value.waybillNumber,
  });
}
